var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    fill: "currentColor",
    className: "w-6 h-6 text-gray-400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 23.73l-.3-1.4c-.93 1.14-1.95 1.7-3.05 1.7-1.13 0-1.95-.32-2.43-.97-.5-.6-.73-1.69-.73-3.23V18.5c0-1.7.28-2.9.85-3.6.6-.77 1.62-1.15 3.05-1.15.44 0 .77.02.97.06.24 0 .45.04.61.12l.24.06v-1.52c0-.86-.12-1.4-.36-1.65-.16-.28-.65-.43-1.46-.43-.65 0-1.53.23-2.62.68l-1.04-2.38a7.81 7.81 0 014.2-1.1c1.43 0 2.5.3 3.23.92.7.56 1.04 1.82 1.04 3.77v11.46h-2.2zm-.79-7.31c-.28-.16-.6-.25-.97-.25-.7 0-1.16.2-1.4.61-.25.37-.37 1.06-.37 2.08v.54c0 .78.08 1.26.25 1.47.16.24.46.36.9.36.54 0 1.07-.32 1.6-.97v-3.84zm-11.03 2H3.96l-.8 5.31H0L3.72 1h4.14l4.27 22.73H8.96l-.98-5.3zM5.85 5.76l-1.4 9.45h2.92L5.85 5.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name-icon.8f9fd728eb4719752f04166f222f2623.svg";
export { ForwardRef as ReactComponent };